<template>
  <div id="billing-detail" class="table-responsive">
    <table
      class="table table-sm table-striped table-hover table-bordered ledger"
    >
      <thead>
        <tr>
          <th scope="col">&nbsp;</th>
          <th scope="col">Tax Bill</th>
          <th scope="col">Adjustments</th>
          <th scope="col">Balance</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in items"
          v-bind:key="item.RowCaption"
          :style="
            item.RowCaption == 'Tax and Penalty:' ||
            item.RowCaption == 'Subtotal:'
              ? 'border-top: 2px solid #666'
              : ''
          "
        >
          <th scope="row" v-html="formatRowCaption(item.RowCaption)"></th>
          <td>{{ index >= 25 ? null : item.TaxBill | currency }}</td>
          <td>{{ index >= 25 ? null : item.Adjustments | currency }}</td>
          <td>{{ item.Balance | currency }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<style scoped>
::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}
#billing-detail,
table {
  scrollbar-width: 0px !important;
  scrollbar-color: transparent !important;
}
</style>
<script>
/* eslint-disable-invalid-first-character-of-tag-name */

export default {
  methods: {
    formatRowCaption(caption) {
      if (caption === "Circuit Breaker:" || caption === "Over 65 CB:") {
        return caption.replace(":", " Credit:");
      } else if (caption === "20% Penalty:") {
        return "Late Penalty:";
      } else {
        return caption;
      }
    },
  },
  props: {
    items: {
      required: true,
      type: Array,
    },
  },
};
</script>
